import * as React from 'react'

import { Box, Icon, Link, Text, useToggle } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import { useGetCurrentSession } from 'modules/core/hooks/useGetCurrentSession'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import { employeeReferenceContract } from 'modules/contracts/lib/utils'
import contractVersions from 'modules/contracts/store/collections/contractVersions'
import RegularAccessModal from 'modules/employees/components/Actions/RegularAccessModal'
import { hideAccessBannerForEmployee } from 'modules/employees/lib/hideAccessBanner'
import type Employee from 'modules/employees/store/models/Employee'
import { Process } from 'modules/processes/hooks/useProcesses'

interface Props {
  employee: Employee
  onboardingProcess?: Process
}

const InvitationAccepted = ({ employee, onboardingProcess }: Props) => {
  const [openRegularAccessModal, toggleRegularAccessModal] = useToggle(false)
  const { canCreateEmployees, employee: currentEmployee } = useGetCurrentSession()

  if (
    hideAccessBannerForEmployee({ employee, canCreateEmployees, currentEmployee }) ||
    !onboardingProcess
  ) {
    return null
  }

  const date = employeeReferenceContract(contractVersions, employee)?.startsOn

  // Return null if date is older than or equal to today
  if (date && date.isSameOrBefore(moment(), 'day')) {
    return null
  }

  const startDate = () => {
    if (date === undefined || date === null) {
      return
    }

    return dateToString(date, 'ui')
  }

  return (
    <Box paddingBottom="s32" paddingX="s64">
      <Box
        borderRadius={{ all: 'abs016' }}
        background="viridian100"
        padding="s12"
        paddingLeft="s16"
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
      >
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" width="full">
          <Box gap="s12" flexDirection="row" alignItems="center" paddingRight="s64">
            <Box background="viridian1000" borderRadius={{ all: 'abs008' }} padding="s2">
              <Icon.Medium icon="lightbulb" color="grey000White" />
            </Box>
            <Box>
              <Text.Normal weight="medium">
                {i18n.t('employees.creation.invitation_accepted.with_onboarding_process', {
                  employee_name: employeeUser(employee).fullName(),
                  start_date: startDate(),
                  onboarding_name: onboardingProcess?.name,
                })}
              </Text.Normal>
            </Box>
          </Box>

          <Box flexNoShrink>
            <Link.Touchable onClick={toggleRegularAccessModal(true)}>
              {i18n.t('employees.regular_access_action')}
            </Link.Touchable>
          </Box>
        </Box>
      </Box>
      {openRegularAccessModal && (
        <Box width="full">
          <RegularAccessModal employee={employee} onClose={toggleRegularAccessModal(false)} />
        </Box>
      )}
    </Box>
  )
}

export default observer(InvitationAccepted)
